import PulseLoader from 'react-spinners/PulseLoader';
import React from 'react';
import { PURPLE } from 'utils/constants/theme';

const ContentLoading: React.FC<{}> = (): JSX.Element => {
  return <PulseLoader size={7} color={PURPLE} />;
};

export default ContentLoading;
